import React from "react"
import Action from "@kit/design/modal/action"
import Icon from "@kit/design/icon"
import { ConfirmModal } from "@kit/design/modal"

const UnauthorizedUpgrade = ({ onClose }) => {
  return (
    <ConfirmModal
      data-testid="unauthorized-upgrade"
      onClose={onClose}
      label="This isn't available on your plan"
      picture={
        <Icon
          name="alert-circle"
          className="w-10 h-10 p-2 rounded-full bg-blue-50 text-blue-600"
        />
      }
    >
      Please contact your account admin to upgrade your plan if you require
      access to additional features.
      <Action is="secondary" onClick={onClose}>
        Ok
      </Action>
    </ConfirmModal>
  )
}

export default UnauthorizedUpgrade
